import ngEnumeration from 'utility-ng-enumeration';
import Interface from 'utility-js-interface';

const forceLoadNGEnumeration: any = ngEnumeration;

window['Interface'] = Interface;
angular.module('utility-ng-interface', ['utility-ng-enumeration']).constant('Interface', Interface);

export default Interface;



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-interface/src/core.ts